export function getCookieFactory(source: string): (name: string) => string | null {
    return function getCookie(name: string): string | null {
        const cookies: Record<string, string> = {};

        source.split(';')
            .map((el) => el.trim())
            .filter(Boolean)
            .forEach((cookie) => {
                const separatorIndex = cookie.indexOf('=');
                const key = cookie.substring(0, separatorIndex);
                const value = decodeURIComponent(cookie.substring(separatorIndex + 1));
                cookies[key.trim()] = value.trim();
            });

        return cookies[name];
    };
}

export const getCookie = getCookieFactory(document.cookie);

export function setCookie(
    key: string,
    value: string,
    expiresDays: number,
    encode = true,
    domain: string | null = null,
): void {
    const date = new Date();
    date.setTime(date.getTime() + daysToMs(expiresDays));
    const cookieKey = encode ? encodeURIComponent(key) : key;
    const cookieValue = encode ? encodeURIComponent(value) : value;
    let cookieDomain = domain ? ` domain=${domain}` : '';
    window.document.cookie = `${cookieKey}=${cookieValue};expires=${date.toUTCString()}; path=/; Secure; SameSite=Lax;${cookieDomain}`;
}

function daysToMs(days: number): number {
    return days * 24 * 60 * 60 * 1_000;
}
